(function () {
  angular
    .module("akitabox.ui.dialogs.bulkEdit.pinField")
    .factory("BulkEditPinFieldDialog", BulkEditPinFieldDialog);

  /* @ngInject */
  function BulkEditPinFieldDialog($log, $mdDialog, $mdMedia, $q) {
    const modal = {
      templateUrl:
        "app/core/ui/dialogs/bulk-edit/pin-field/bulk-edit-pin-field.dialog.html",
      controller: "BulkEditPinFieldDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      escapeToClose: false,
      clickOutsideToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    return { show: show };

    /**
     * Show bulk edit dialog for pin type fields, required params:
     * - `options.locals.model`
     * - `options.locals.selectedItems`
     * - `options.locals.buildingId`
     *
     * @param {Object} options Dialog options
     * @return {Promise<Object|Error>} Promise that resolves with the edited items
     */
    function show(options) {
      if (
        !options ||
        !options.locals ||
        !options.locals.model ||
        !options.locals.selectedItems ||
        !options.locals.buildingId ||
        (options.locals.model !== "assets" && options.locals.model !== "rooms")
      ) {
        $log.error(
          `
          BulkEditPinFieldDialog: you must pass in model, selectedItems and buildingId via locals.
          The model param must only be either "assets" or "rooms"
          `
        );
        return $q.reject("Sorry, we weren't able to complete your request.");
      }

      return $mdDialog.show(angular.extend({}, modal, options));
    }
  }
})();
